module.exports = __webpack_public_path__ + "img/proyecto_13_mv.ace3150c.png";